import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { connect } from 'pwa-helpers/connect-mixin';
// eslint-disable-next-line import/no-cycle
import LitElementExtended from '../classes/LitElementExtended';
import featureDef from '../defs/features';
import store from '../store';
import { ConsentType } from '../types/common';

@customElement('tef-coms-consent')
export default class TefComsConsent extends connect(store)(LitElementExtended) {
  consent?: ConsentType;

  required = false;

  layout = 'default';

  mode = '';

  constructor() {
    super();
    this.consent = undefined;
    this.required = false;
    this.layout = 'default';
    this.mode = '';
  }

  createRenderRoot() {
    return this; // no shadow DOM for sub-components
  }

  static get properties() {
    return {
      consent: { type: Object },
      required: { type: Boolean },
      layout: { type: String },
      mode: { type: String },
    };
  }

  updated() {
    this.replaceElements();
  }

  get features() {
    const { id } = this.consent;
    const existedFeatures = featureDef.filter((feature) => this.consent[feature]);

    if (existedFeatures.length < 1) {
      return null;
    }

    const disabled = !!this.mode.includes('multiedit');

    const featuresTemplate = this.getTemplateFn('featuresTemplate');
    return featuresTemplate(this.consent, disabled, id);
  }

  get consentblock() {
    const disabled = !!this.mode.includes('multiedit');

    const consentClasses = ['form-row'];
    const checkboxClasses = ['form-group-checkbox'];

    if (disabled) {
      consentClasses.push('coms-features');
    } else if (this.layout === 'group') {
      consentClasses.push('form-row--group');
      checkboxClasses.push('form-group-checkbox--size-small');
    }

    const consentTemplate = this.getTemplateFn('consentTemplate');

    return consentTemplate(consentClasses, checkboxClasses, this.consent, disabled, this);
  }

  get viewTemplate() {
    return this.template;
  }

  get template() {
    const { scope } = this.consent;

    return html`
      ${this.required ? unsafeHTML(scope) : html`${this.consentblock}`}
    `;
  }

  render() {
    return html`
      ${this.mode && this.mode.includes('multiedit') ? this.viewTemplate : this.template}
    `;
  }
}
